module.exports = __webpack_public_path__ + "static/media/logo.0bf89bb6.svg";